import { isScrollingDown } from '../util'

let logo
let darkElements
let navBtn

let logoTopOffset
let logoBottOffset
let logoHeight
let darkElementItems

let offset
let offsetScroll
let turnedLight
let currentDarkElement
let lightDifferenceAmount
let lightDifferencePercent
let darkDifferenceAmount
let darkDifferencePercent

let lockColor

let animationFrame

const mediaQuery = '(min-width: 48em)'

export function LogoColor() {
    logo = document.querySelector('.js-logo')
    if (!logo) {
        return
    }

    navBtn = document.querySelector('.js-nav-btn')

    const { top, height } = logo.getBoundingClientRect()
    logoTopOffset = top
    logoBottOffset = top + height
    logoHeight = height

    darkElements = document.querySelectorAll('.js-dark-bg')
    darkElements = Array.from(darkElements)

    if (!darkElements.length) {
        return
    }

    updateDarkElementPositions()
    updateScroll()
    window.addEventListener('scroll', updateScroll)
    window.addEventListener('resize', updateDarkElementPositions)
}

function updateDarkElementPositions() {
    const darkElementItemsTmp = darkElements.map((el) => {
        const top = el.offsetTop
        const height = el.offsetHeight
        return {
            el,
            top,
            bot: top + height
        }
    })

    darkElementItems = []
    for (let i = 0; i < darkElementItemsTmp.length; i++) {
        if (darkElementItemsTmp[i].merged) {
            continue
        }

        if (i + 1 > darkElementItemsTmp.length - 1) {
            darkElementItems.push(darkElementItemsTmp[i])
            continue
        }

        if (darkElementItemsTmp[i].bot === darkElementItemsTmp[i + 1].top) {
            darkElementItemsTmp[i + 1].merged = true
            darkElementItemsTmp[i].bot = darkElementItemsTmp[i + 1].bot
        }

        darkElementItems.push(darkElementItemsTmp[i])
    }

    if (!window.matchMedia(mediaQuery).matches) {
        setLockColor(true)
    } else {
        setLockColor(false)
        updateScroll()
    }
}

export function setLockColor(lock = false) {
    lockColor = lock
}

export function updateScroll() {
    if (animationFrame || lockColor) {
        return
    }

    animationFrame = requestAnimationFrame(() => {
        let currentScroll = window.scrollY

        offset = isScrollingDown ? logoBottOffset : logoTopOffset

        offsetScroll = currentScroll + offset
        turnedLight = false

        if (darkElementItems) {
            darkElementItems.forEach((el) => {
                if (offsetScroll > el.top && offsetScroll < el.bot) {
                    currentDarkElement = el
                    turnLogoLight(offsetScroll)
                    turnedLight = true
                }
            })
        }

        if (!turnedLight) {
            turnLogoDark(offsetScroll)
        }

        animationFrame = null
    })
}

function turnLogoLight(offsetScroll) {
    lightDifferencePercent = 0

    if (currentDarkElement) {
        lightDifferenceAmount = isScrollingDown
            ? offsetScroll - currentDarkElement.top
            : currentDarkElement.bot - offsetScroll
        lightDifferencePercent = lightDifferenceAmount / logoHeight
    }

    if (lightDifferencePercent >= 0 && lightDifferencePercent <= 1) {
        updateLogoProgress(lightDifferencePercent)
        setScrollDirection()
    } else {
        updateLogoProgress(0)
        setScrollDirection()
    }

    if (lightDifferencePercent > 1) {
        setStyle(false)
    }
}

function turnLogoDark(offsetScroll) {
    darkDifferencePercent = 1

    if (currentDarkElement) {
        darkDifferenceAmount = isScrollingDown
            ? offsetScroll - currentDarkElement.bot
            : currentDarkElement.top - offsetScroll
        darkDifferencePercent = darkDifferenceAmount / logoHeight
    }

    if (darkDifferencePercent >= 0 && darkDifferencePercent <= 1) {
        updateLogoProgress(darkDifferencePercent)
        setScrollDirection()
    } else {
        updateLogoProgress(0)
        setScrollDirection()
    }

    if (darkDifferencePercent > 1) {
        setStyle(true)
    }
}

export function setLogoDark() {
    updateLogoProgress(0)
    setStyle(true)
}

export function setLogoLight() {
    updateLogoProgress(0)
    setStyle(false)
}

function updateLogoProgress(percent) {
    logo.style.setProperty('--progress', `${percent * 100}%`)
}

function setStyle(isDark) {
    logo.dataset.style = isDark ? 'dark' : 'light'
    navBtn.dataset.color = isDark ? 'dark' : 'light'
}

function setScrollDirection() {
    logo.dataset.scrollDir = isScrollingDown ? 'down' : 'up'
}
